import { render, staticRenderFns } from "./StandardView.vue?vue&type=template&id=26681fd7&scoped=true"
import script from "./StandardView.vue?vue&type=script&lang=js"
export * from "./StandardView.vue?vue&type=script&lang=js"
import style0 from "./StandardView.vue?vue&type=style&index=0&id=26681fd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26681fd7",
  null
  
)

export default component.exports